export const dictionaryErrors = { SERIEDES: "Nombre de la Serie", SERIEPAT: "Nombre del Path" };
